// A timeslot's cancellationReason is a free-text string that may hold a
// JSON-encoded preset snapshot ({ title, subtext, color }). These helpers
// centralize the "is it a preset?" sniff so consumers don't each re-parse.

function parseCancellationPreset(reason) {
    if (typeof reason !== 'string' || !reason) return null;
    try {
        const parsed = JSON.parse(reason);
        if (parsed && typeof parsed.title === 'string') {
            return {
                title: parsed.title,
                subtext: typeof parsed.subtext === 'string' ? parsed.subtext : '',
                color: typeof parsed.color === 'string' ? parsed.color : null,
            };
        }
    } catch {
        // plain string, not a preset
    }
    return null;
}

// Display string for a cancellation reason: "Title, Subtext" for a preset,
// otherwise the raw text.
export function formatCancellationReason(reason) {
    const preset = parseCancellationPreset(reason);
    if (!preset) return reason;
    return [preset.title, preset.subtext].filter(Boolean).join(', ');
}
